const stateManager = require('../../utils/state/stateManager');
const constants = require('../../utils/domain/constants');
const localizationUtils = require('../../utils/localization/localizationUtils');
const logger = require('../../utils/logger/logger');
const basketUtil = require('../../utils/basket/basketUtil');
const apiProxy = require('../../utils/api/apiProxy');

export async function createPaymentIntent(amount)
{
    const paymentCurrency = localizationUtils.getCurrency();

    const onlinePaymentConfiguration = stateManager.getStore().getState().onlinePaymentConfiguration;

    if(onlinePaymentConfiguration.paymentProvider === constants.WebPaymentProviders.stripeOverPhone)
    {
        const { payoutStoreId, transactionPercentageFee, transactionFixedFee, transactionTaxRate, connectAccountId } = onlinePaymentConfiguration;

        let feeAmount = onlinePaymentConfiguration.transactionFixedFee;
        feeAmount = feeAmount + (amount * onlinePaymentConfiguration.transactionPercentageFee)/100;
        feeAmount = ((feeAmount * 100).toFixed(0) / 100);
        
        const transactionTax = (feeAmount * transactionTaxRate/ 100).toFixed(2) * 1
        feeAmount += transactionTax;

        const transfer_data = {};
        transfer_data.destination = onlinePaymentConfiguration.connectAccountId;

        const state = stateManager.getStore().getState();
        const basket = state.basket;
    
        var metaData = {};
        metaData.sale_type = "StripeOverPhone";
        metaData.flipdish_store_id = payoutStoreId;
        metaData.flipdish_fee_percent = transactionPercentageFee;
        metaData.flipdish_fee_fixed = transactionFixedFee;
        metaData.transaction_tax_rate = transactionTaxRate;
        metaData.transaction_tax_amount = transactionTax;
        metaData.pos_sale_id = basket.order.id;
        metaData.pos_tip_amount = "0.0";
        metaData.franchisor_id = state.franchisorId;
        metaData.franchisee_id = state.franchiseeId;
        metaData.property_id = state.propertyId;
        metaData.sale_business_date = state.basket.order.businessDate;

        const paymentRequestPayload = 
        {
            capture_method: 'automatic',
            on_behalf_of: connectAccountId,
            transfer_data,
            metadata: metaData,
        }

        const paymentRequest = 
        {
            storefrontId: stateManager.getStore().getState().storefront.id,
            processor: constants.WebPaymentProviders.stripe,
            payload: paymentRequestPayload
        }

        try 
        {
            const paymentIntent = await apiProxy.post("paymentIntent", paymentRequest, true);

            logger.info(`Payment Intent received for order number: ${state.basket.order.number}`,  
            {  
                ...getTracingContext(),  
                paymentIntentId: paymentIntent?.id,  
                paymentIntentStatus: paymentIntent?.status  
            });

            return paymentIntent;
        } 
        catch (error) 
        {
            logger.error(`Payment Intent failed for order number: ${state.basket.order.number}`, getTracingContext());
        }
    }

    if(onlinePaymentConfiguration.paymentProvider === constants.WebPaymentProviders.stripe)
    {
        const paymentIntent = {
            amount: (amount * 100).toFixed(0),
            currency: paymentCurrency,
            capture_method: 'automatic',
        }

        return paymentIntent
    }

    return null;
}

function getTracingContext()
{
    const state = stateManager.getStore().getState();
    const basket = state.basket;

    return {
        franchisorId: state.franchisorId,
        franchiseeId: state.franchiseeId,
        propertyId: state.propertyId,
        orderId: basket.order.id,
        orderNumber: basket.order.number,
        amount: basketUtil.getTotalBasketPrice(),
    }
}